var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 22 28.18",
    style: {
      enableBackground: "new 0 0 22 28.18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A499A;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,28.05L11,28.05c-0.27,0-0.53-0.11-0.71-0.31C9.87,27.29,0.15,16.76,0.15,10.99 C0.15,5.01,5.02,0.14,11,0.14s10.85,4.87,10.85,10.85c0,5.77-9.72,16.3-10.14,16.75C11.53,27.94,11.27,28.05,11,28.05z M11,2.08 c-4.91,0-8.91,4-8.91,8.91c0,3.83,5.89,11.25,8.91,14.65c3.02-3.4,8.91-10.81,8.91-14.65C19.91,6.08,15.91,2.08,11,2.08z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11,15.4c-2.69,0-4.88-2.19-4.88-4.88c0-2.69,2.19-4.88,4.88-4.88c2.69,0,4.88,2.19,4.88,4.88 C15.88,13.21,13.69,15.4,11,15.4z M11,7.57c-1.62,0-2.94,1.32-2.94,2.94c0,1.62,1.32,2.94,2.94,2.94c1.62,0,2.94-1.32,2.94-2.94 C13.94,8.89,12.62,7.57,11,7.57z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdress);
export default __webpack_public_path__ + "static/media/adress.ae662bebee637f49f7a0de08cac2e5e6.svg";
export { ForwardRef as ReactComponent };